import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const SfMainHeadingText = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '38px',
  color: '#11557D',
}));

export const SfHeadingText = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '20px',
  color: '#000000',
}));

export const SfSubHeadingText = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '21.82px',
  color: '#000000',
}));

export const SfLabelText = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#444444',
}));

export const SfDescriptionText = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#444444',
  margin: '28px 0 32px',
}));

export const SfLocationLabelText = styled(Typography)(() => ({
  fontFamily: 'Proxima Nova',
  fontWeight: 500,
  fontSize: '22px',
  lineHeight: '33px',
  color: '#444',
}));

export const SfAccordionSummary = styled(AccordionSummary)(() => ({
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
}));
